/** localStorage keys under which one resizable preview layout keeps its width and collapsed state. */
export const getPreviewLayoutStorageKeys = (storageKey: string) => ({
  width: `${storageKey}Width`,
  collapsed: `${storageKey}Collapsed`,
});
